import React, { Component } from 'react'
import Icon from "../common/icon/icon.component.jsx";

class PaymentTypeIcon extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            type: this.props.value || '',
            className: this.props.className || '',
            icon: this.props.icon || '',
        }
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            type: nextProps.value || '',
            className: nextProps.className || '',
        })
    }

    componentDidMount() { }



    render() {
        if (!this.state.icon && !this.state.type) {
            return ''
        }

        if (this.state.icon) {
            return <Icon className={this.state.className} value={this.state.icon} />
        }

        const icons = {
            'check': 'money-check',
            'cash': 'money-bill-alt',
            'credit-card': 'credit-card',
            'bank-transfer': 'university',
            'credit': 'piggy-bank',
            'external': 'cloud',
            'gift-card': 'gift',
            'on-account': 'coins'
        }

        return <Icon className={this.state.className} value={icons[this.state.type] || 'dollar-sign'} />
    }

}

export default PaymentTypeIcon





// WEBPACK FOOTER //
// ./src/invoice/paymenttypeicon.component.jsx